document.addEventListener('DOMContentLoaded',()=>{
  const btn=document.querySelector('.mobile-menu-btn');
  const menu=document.querySelector('.mobile-menu');
  if(btn&&menu){
    btn.addEventListener('click',()=>{
      const open=btn.getAttribute('aria-expanded')==='true';
      btn.setAttribute('aria-expanded',String(!open));
      menu.hidden=open;
    });
  }
  document.querySelectorAll('.faq-list details').forEach(d=>{
    d.addEventListener('toggle',()=>{const s=d.querySelector('summary span'); if(s)s.textContent=d.open?'−':'+'});
  });
});
